<template>
  <div class="app flex-row mt-3 animated fadeIn">
    <b-container>
      <b-row class="justify-content-center">
        <b-col xl="5" lg="7" md="9">
          <!-- <b-img class="d-block mx-auto mb-3" src="/img/logo-full.png" fluid :alt="$t('shared.AppLogo')" /> -->

          <b-alert :show="errors.any()" variant="danger" class="px-4 my-2">
            <ul class="m-0 px-1">
              <li v-for="err in errors.all()" :key="err">{{ err }}</li>
            </ul>
          </b-alert>

          <b-card class="mb-3 p-4">
            <h1 class="h4">
              Reset Password
            </h1>
            <p class="text-muted">Enter new Password</p>
            <b-form @submit.prevent="submit">
              <b-input-group class="mb-3">
                <b-input-group-prepend is-text>New Password</b-input-group-prepend>
                <b-form-input
                  type="password"
                  v-model="model.Password"
                  name="New Password"
                  v-validate="'required|confirmed:pwdcfrm'"
                ></b-form-input>
              </b-input-group>
              <b-input-group class="mb-3">
                <b-input-group-prepend is-text>Confirm Password</b-input-group-prepend>
                <b-form-input v-model="model.ConfirmPassword" type="password" ref="pwdcfrm" />
              </b-input-group>
              <b-button :disabled="progressing" @click="submit" variant="warning" class="btn-block">Reset Password</b-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'forgot-password',
  props: ['token'],
  data() {
    return {
      model: {
        Password: null,
        ConfirmPassword: null,
        ReturnToken: this.token
      },
      progressing: false,
      newPassword: null,
      pwdcfrm: null
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.progressing = true
          this.$api.account
            .ResetPassword(this.model, true)
            .then(() => {
              this.progressing = false
              this.$showSuccess('Your Password Has Changed')
              this.$router.push('/')
            })
            .catch(err => {
              this.progressing = false
              if (err.response.data) {
                this.$showError(err.response.data.Message)
              } else {
                this.$showError('error was occured')
              }
            })
        }
      })
    }
  }
}
</script>
